import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const AssetLoader: React.FC<SvgProps> = (props) => {
  return (
    <Svg
      className="replo-animate-spinner"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/Svg"
      {...props}
    >
      <g clipPath="url(#clip0_491_8765)">
        <path
          d="M45.91 14.0902L42.375 17.6252C39.5123 14.7622 35.7454 12.9804 31.7162 12.5833C27.6871 12.1863 23.6448 13.1986 20.2783 15.4477C16.9118 17.6968 14.4294 21.0437 13.2539 24.918C12.0783 28.7923 12.2826 32.9543 13.8317 36.6949C15.3808 40.4355 18.1791 43.5233 21.7496 45.4321C25.3201 47.3408 29.442 47.9525 33.4129 47.1629C37.3839 46.3733 40.9582 44.2313 43.5269 41.1018C46.0956 37.9723 47.4997 34.0489 47.5 30.0002H52.5C52.5 35.2057 50.695 40.2502 47.3926 44.274C44.0903 48.2979 39.4948 51.0522 34.3894 52.0677C29.2839 53.0832 23.9842 52.2971 19.3934 49.8432C14.8026 47.3893 11.2047 43.4195 9.21265 38.6103C7.22063 33.801 6.95778 28.4498 8.46889 23.4685C9.98 18.4871 13.1716 14.1839 17.4998 11.2919C21.828 8.3999 27.0251 7.09813 32.2055 7.60839C37.386 8.11865 42.2292 10.4094 45.91 14.0902V14.0902Z"
          fill="#F1F5F9"
        />
      </g>
      <g clipPath="url(#clip1_491_8765)">
        <path
          d="M30 7.5C35.9674 7.5 41.6903 9.87053 45.9099 14.0901C50.1295 18.3097 52.5 24.0326 52.5 30H47.5C47.5 25.3587 45.6563 20.9075 42.3744 17.6256C39.0925 14.3437 34.6413 12.5 30 12.5V7.5Z"
          fill="#2563EB"
        />
      </g>
      <defs>
        <clipPath id="clip0_491_8765">
          <rect width="60" height="60" fill="white" />
        </clipPath>
        <clipPath id="clip1_491_8765">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default AssetLoader;
